export default __webpack_public_path__ + "static/media/miguel-lopes-18.7b1cdd1a.jpg";